import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, MenuItem, Select } from "@mui/material";
import { LANGUAGES } from "../../contants";
import styles from "./currencySelector.module.scss";

function CurrencySelector({ currency, setter = () => {} }) {
  const { i18n } = useTranslation(["common"]);
  const handleChange = (event) => {
    setter(event.target.value);
  };
  const [possibleCurrencies, setPossibleCurrencies] = useState([]);

  useEffect(() => {
    const possibleCur =
      (LANGUAGES[i18n.language] || LANGUAGES["en"]).currencies || [];
    setPossibleCurrencies(possibleCur);

    const defaultCurrency = possibleCur[0];
    if (defaultCurrency) {
      setter(possibleCur[0]);
    }
  }, [i18n.language, setter]);

  if (possibleCurrencies.length > 1) {
    return (
      <div className={styles.mainContainer}>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }}>
          <Select value={currency} label="Age" onChange={handleChange}>
            {possibleCurrencies?.map((c) => (
              <MenuItem value={c} key={c.label}>
                {c.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  } else {
    return null;
  }
}

export default CurrencySelector;
